import { configureStore } from '@reduxjs/toolkit';
// Importa tus slices aquí
import strapiSlice from './strapi/strapiSlice';
import { brokersBusinessApi } from '../api/brokersBusinessApi';
import { strapiApi } from '../api/strapiApi';
import { setupListeners } from '@reduxjs/toolkit/query/react';

export const store = configureStore({
  reducer: {
    strapi: strapiSlice,
    [brokersBusinessApi.reducerPath]: brokersBusinessApi.reducer,
    [strapiApi.reducerPath]: strapiApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      brokersBusinessApi.middleware,
      strapiApi.middleware,
    ),
});

setupListeners(store.dispatch);


